// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1tFn2","col":"CardReaderDesc_col__2cYCV","label":"CardReaderDesc_label__12yML"};